import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  Divider,
  SimpleGrid,
  Stack,
} from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";

const ViewLoyaltyConfigDrawer = ({ isOpen, onClose, config }) => {
  const [localConfig, setLocalConfig] = useState(config);

  useEffect(() => {
    if (config) {
      setLocalConfig(config);
    }
  }, [config]);

  if (!localConfig) return null;

  const coreFields = [
    "points_per_pula",
    "referral_percentage",
    "min_points",
    "max_points",
    "driver_referral_base",
  ];

  const tierFields = [
    "bronze_threshold",
    "silver_threshold",
    "gold_threshold",
    "platinum_threshold",
  ];

  const multiplierFields = [
    "bronze_multiplier",
    "silver_multiplier",
    "gold_multiplier",
    "platinum_multiplier",
  ];

  const renderGroup = (title, fields) => (
    <Box>
      <Text fontSize="md" fontWeight="bold" mb={3}>
        {title}
      </Text>

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
        {fields.map((key) => (
          <Box
            key={key}
            border="1px"
            borderColor="gray.200"
            borderRadius="md"
            p={3}
          >
            <Text fontSize="xs" color="gray.500" mb={1}>
              {key.replace(/_/g, " ").toUpperCase()}
            </Text>

            <Text fontWeight="bold">{localConfig[key]}</Text>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  );

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<Text fontWeight="bold">Loyalty Config</Text>}
      bodyContent={
        <Stack spacing={6}>
          <Box>
            <Text fontSize="xl" fontWeight="bold">
              Configuration Details
            </Text>
            <Divider mt={2} />
          </Box>
          {renderGroup("Core Settings", coreFields)}
          {renderGroup("Tier Thresholds", tierFields)}
          {renderGroup("Tier Multipliers", multiplierFields)}
        </Stack>
      }
    />
  );
};

export default ViewLoyaltyConfigDrawer;